/** TS-8 — client mirror of server bridge flag (defaults on). */
export function documentBuilderSignBridgeEnabled(): boolean {
  const raw = import.meta.env.VITE_DOCUMENT_BUILDER_SIGN_BRIDGE;
  if (raw === undefined || raw === "") return true;
  return String(raw).trim().toLowerCase() !== "false";
}
